import { Route } from "vue-router";

import MessageReplyPage from "./components/MessageReplyPage.vue";

export default [
  {
    path: "/messaging/reply",
    name: "MessageReplyPage",
    component: MessageReplyPage,
    props: (route: Route) => {
      return {
        plushieId: route.query.plushieId,
      };
    },
    meta: {
      auth: true,
    },
  },
];
